import React, { useEffect, useRef } from "react";
import { useCart } from "../contexts/CartContext";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const oneSystem = "https://onesystem.asherjewels.com.ph/";

export default function Slidebar() {
  const {
    cartItems,
    sidebarOpen,
    toggleSidebar,
    closeSidebar,
    removeFromCart,
  } = useCart();

  const { user } = useAuth();
  const navigate = useNavigate();
  const sidebarRef = useRef(null);

  const totalPrice = cartItems.reduce(
    (acc, item) => acc + parseFloat(item.pricePHP) * item.qty,
    0
  );

  const formattedTotalPrice = totalPrice.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const handleCheckout = () => {
    if (user) {
      Swal.fire({
        title: "Proceed to Checkout?",
        text: "You're about to proceed to checkout.",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#b8860b",
        cancelButtonColor: "#aaa",
        confirmButtonText: "Yes, proceed",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/checkout");
        }
      });
    } else {
      Swal.fire({
        title: "Login Required",
        text: "You need to log in before proceeding to checkout.",
        icon: "warning",
        confirmButtonColor: "#b8860b",
        confirmButtonText: "Login Now",
      }).then(() => {
        toggleSidebar();
        navigate("/login?redirect=/checkout");
      });
    }
  };

  const handleRemove = async (id) => {
    console.log("🧹 Removing item with ID:", id);
    await removeFromCart(id);
    console.log("✅ Remove function finished");
  };

  // 🔁 Close sidebar on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        closeSidebar();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [sidebarOpen, closeSidebar]);

  if (!sidebarOpen) return null;

  return (
    <div className="sidebar-overlay">
      <div ref={sidebarRef} className={`slidebar open`}>
        <button className="close-btn" onClick={closeSidebar}>
          ×
        </button>
        <h2>Your Cart</h2>
        {cartItems.length === 0 ? (
          <p>Your cart is empty.</p>
        ) : (
          <>
            <ul>
              {cartItems.map((item) => {
                const itemTotal = (
                  parseFloat(item.pricePHP) * item.qty
                ).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                });
                return (
                  <li key={item.id} className="slidebar-item">
                    <img
                      src={`${oneSystem}${item.imageUrl}`}
                      alt={item.name}
                      width={60}
                      height={60}
                    />
                    <div className="slidebar-item-details">
                      <h4>{item.name}</h4>
                      <p>Qty: {item.qty}</p>
                      <p>Price: ₱{itemTotal}</p>
                      <button
                        className="remove-btn"
                        onClick={() => handleRemove(item.id)}
                      >
                        Remove
                      </button>
                    </div>
                  </li>
                );
              })}
            </ul>
            <div
              style={{
                borderTop: "1px solid #b8860b",
                paddingTop: "1rem",
                marginTop: "1rem",
                fontWeight: "700",
                fontSize: "1.2rem",
                color: "#8a6d3b",
              }}
            >
              Total: ₱{formattedTotalPrice}
            </div>
            <button
              onClick={handleCheckout}
              style={{
                marginTop: "1rem",
                width: "100%",
                padding: "0.75rem",
                backgroundColor: "#b8860b",
                border: "none",
                borderRadius: "6px",
                color: "#fff",
                fontWeight: "700",
                fontSize: "1rem",
                cursor: "pointer",
                boxShadow: "0 4px 10px rgba(184,134,11,0.5)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#d4af37")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "#b8860b")
              }
            >
              Checkout
            </button>
          </>
        )}
      </div>
    </div>
  );
}
